import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'resource',
  action: ActionType.READ,
};
const createPermission = {
  resource: 'resource',
  action: ActionType.CREATE,
};
const updatePermission = {
  resource: 'resource',
  action: ActionType.UPDATE,
};
const deletePermission = {
  resource: 'resource',
  action: ActionType.UPDATE,
};

export const Resource = {
  list: listPermission,
  create: createPermission,
  update: updatePermission,
  delete: deletePermission,
};
